export default __webpack_public_path__ + "static/media/informacao11.3a0aeaf5.pdf";